import Icon from '../components/Icon.vue'

Icon.register({"gitlab":{"width":1792,"height":1792,"paths":[{"d":"M104 706l792 1015-868-630q-18-13-25-34.5t0-42.5l101-308v0zM566 706h660l-330 1015v0zM368 94l198 612h-462l198-612q8-23 33-23t33 23zM1688 706l101 308q7 21 0 42.5t-25 34.5l-868 630 792-1015v0zM1688 706h-462l198-612q8-23 33-23t33 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gitlab.js
// module id = 1436
// module chunks = 0